<template>
  <div>
    <google-map :style="{ width: 'auto', height: height + 'px' }" :zoomLevel="getZoomLevel" ref="gMap" />
    <div v-if="showOpenPlaceList()" class="absolute inline-block -mt-8 w-full h-10 text-center">
      <a @click="openPlaceList" class="inline-flex justify-center items-center px-4 h-8 bg-white rounded-t text-link shadow-sm">{{ $t('tour_search_place') }}</a>
    </div>
    <drawer />
    <location-button @getLocation="onGetLocation" />
    <busstop-menu />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GoogleMap from './GoogleMap'
import LocationButton from '../../molecules/LocationButton'
import Drawer from './Drawer'
import BusstopMenu from './BusstopMenu'
import Constants from "../../../constants"
import { event } from 'vue-gtag'

export default {
  components: {
    GoogleMap,
    LocationButton,
    Drawer,
    BusstopMenu
  },
  props:{
    zoomLevel: {
      type: Number,
      required:false,
      default: 15
    }
  },
  data () {
    return {
      modal: {
        show: false,
        kind: 'error',
        target: undefined
      },
      windowHeight: window.innerHeight
    }
  },
  mounted () {
    window.addEventListener('resize', ()=>{
      this.windowHeight = window.innerHeight
    })
  },
  methods: {
    onGetLocation: function (location) {
      this.$store.dispatch('map/updateCenter', location)
    },
    openPlaceList: function () {
      let center = this.$store.getters['map/getCenter']
      event("おすすめスポット表示", {
        recommend_lat: center.lat,
        recommend_lng: center.lng,
        recommend_latLng: center.lat + "," + center.lng
      });
      this.$store.dispatch('drawer/open', { component: 'PlaceList' })
    },
    closeModal: function () {
      this.modal.show = false
    },
    showModal: function () {
      this.modal.show = true
    },
    showOpenPlaceList: function () {
      return Constants.ENABLED_MAP_SEARCH_PLACE
    },
    mapInitialized: function () {
      this.$refs.gMap.mapInitialized()
    },
    fitBoundsPlan: function () {
      this.$refs.gMap.fitBoundsPlan()
    }
  },
  computed: {
    ...mapGetters({
      center: 'map/getCenter'
    }),
    height: function () {
      const isShowBusLocation = this.$store.getters['busLocation/getIsOpen']
      var h = 68
      
      if (isShowBusLocation) {
        const isShowLocation = this.$store.getters['busLocation/getIsShowLocation']
        if (isShowLocation) {
          h = 170
        } else {
          h = 320
        }
      }
      const i = this.windowHeight - h

      this.$store.dispatch('map/updateHeight', i)

      return i
    },
    getZoomLevel() {
      return this.zoomLevel;
    }
  },
  watch: {
    center: function () {
      this.showPlaceList = false
    }
  }
}
</script>
